import { httpClient } from "./httpClient";

export type NotificacaoTesteCanal = "EMAIL" | "WHATSAPP" | "SMS" | "INBOX";

/** Pessoa elegível ao teste: só quem tem identidade vinculada no Hub Identity. */
export interface NotificacaoTesteDestinatario {
  pessoaId: number;
  nome: string;
  email: string;
  telefone?: string;
  identityId: string;
}

export interface EnviarNotificacaoTesteDTO {
  canal: NotificacaoTesteCanal;
  destinatarios: string[];
  corpo: string;
  assunto?: string;
}

export interface NotificacaoTesteResultadoItem {
  destino: string;
  ok: boolean;
  erro?: string;
}

export interface NotificacaoTesteResultado {
  total: number;
  enviados: number;
  falhas: number;
  resultados: NotificacaoTesteResultadoItem[];
}

class NotificacaoTesteService {
  private readonly basePath = "/api/v1/servicos-externos/notificacao-teste";

  public async destinatarios() {
    return await httpClient.get<NotificacaoTesteDestinatario[]>(`${this.basePath}/destinatarios`);
  }

  public async enviar(dto: EnviarNotificacaoTesteDTO) {
    return await httpClient.post<NotificacaoTesteResultado>(`${this.basePath}/enviar`, dto);
  }
}

export const notificacaoTesteService = new NotificacaoTesteService();
